export const routes = {
  any: "*",
  home: "/home",
  login: "/login",
  profile: "/profile",
  user: "/employees",
  document: "/documents"
};
